import { Link, createFileRoute } from '@tanstack/react-router'
import { catalogQueryOptions } from '@/api/accommodation/hooks'
import { Button } from '@/components/ui/button'
import { CatalogContent } from '@/features/accommodation/catalog/CatalogContent'
import { buildCatalogHead } from '@/lib/seo/staticPages'

export const Route = createFileRoute('/_layout/ubytovani/')({
  component: CatalogPage,
  errorComponent: CatalogErrorComponent,
  loader: async ({ context }) => {
    await context.queryClient.query({
      ...catalogQueryOptions(),
      staleTime: 'static',
    })
  },
  head: () => buildCatalogHead(),
})

function CatalogPage() {
  return <CatalogContent />
}

function CatalogErrorComponent() {
  return (
    <div className="container flex min-h-[50vh] flex-col items-center justify-center py-16 text-center">
      <h1 className="mb-2 text-2xl font-semibold text-slate-700">Chyba při načítání</h1>
      <p className="mb-6 max-w-sm text-slate-500">
        Přehled ubytování se nepodařilo načíst. Zkuste to prosím za chvíli znovu.
      </p>
      <Button asChild>
        <Link to="/">Zpět na úvod</Link>
      </Button>
    </div>
  )
}
